import { useViewSettings } from '../../selectors';

export const usePermissions = (): ((feature: string) => boolean) => {
  const { permissions } = useViewSettings();

  return (feature) => {
    return permissions?.[feature] ?? false;
  };
};
